module.exports = __webpack_public_path__ + "img/menu-17.90b355ad.jpg";